import { z } from 'zod';

export const OrganizationSchema = z.object({
  id: z.string(),
  name: z.string().optional(),
  address: z.string(),
  type: z.string(),
  createDate: z.string(),
  customId: z.string().optional(),
  updateDate: z.string().optional(),
});

export type Organization = z.infer<typeof OrganizationSchema>;
